import { gql } from '@apollo/client';

export const INIT_FACEBOOK_AUTH = gql`
  mutation InitFacebookAuth($input: InitFacebookAuthInput!) {
    initFacebookAuth(input: $input) {
      authUrl
    }
  }
`;

export const COMPLETE_FACEBOOK_AUTH = gql`
  mutation CompleteFacebookAuth($input: CompleteFacebookAuthInput!) {
    completeFacebookAuth(input: $input) {
      pageName
      username
      followersCount
    }
  }
`;

export const UNLINK_SOCIAL_MEDIA_CONNECTION = gql`
  mutation UnlinkSocialMediaConnection(
    $input: UnlinkSocialMediaConnectionInput!
  ) {
    unlinkSocialMediaConnection(input: $input) {
      success
    }
  }
`;
